/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alreadyhaveanaccount3Inputs */

const en_alreadyhaveanaccount3 = /** @type {(inputs: Alreadyhaveanaccount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already have an account?`)
};

const de_alreadyhaveanaccount3 = /** @type {(inputs: Alreadyhaveanaccount3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast schon ein Konto?`)
};

/**
* | output |
* | --- |
* | "Already have an account?" |
*
* @param {Alreadyhaveanaccount3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const alreadyhaveanaccount3 = /** @type {((inputs?: Alreadyhaveanaccount3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alreadyhaveanaccount3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_alreadyhaveanaccount3(inputs)
	return de_alreadyhaveanaccount3(inputs)
});
export { alreadyhaveanaccount3 as "alreadyHaveAnAccount" }